module.exports = __webpack_public_path__ + "img/1.55eda80f.png";